import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Panel} from 'react-bootstrap';
import {FlircConfigFile} from "./utils";
import {join as _join} from 'lodash';

class FlircConfigHeader extends Component {
    render() {
        return (
            <Panel header={<h1>Header</h1>}>
                <dl className="dl-horizontal">
                    <dt>Magic</dt>
                    <dd>0x{this.props.flircConfig.header.magic.toString(16).toUpperCase()}</dd>
                    <dt>Version</dt>
                    <dd>{_join(this.props.flircConfig.header.version, '.')}</dd>
                    <dt># of patterns</dt>
                    <dd>{this.props.flircConfig.header.size}</dd>
                    <dt>CRC</dt>
                    <dd>0x{this.props.flircConfig.header.crc.toString(16).toUpperCase()}</dd>
                </dl>
            </Panel>
        )
    };
}

FlircConfigHeader.propTypes = {
    flircConfig: PropTypes.instanceOf(FlircConfigFile).isRequired,
};

export default FlircConfigHeader;



// WEBPACK FOOTER //
// ./src/FlircConfigHeader.js